import script from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=3ea36b91&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea36b91"]])

export default __exports__